import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Header from '../../components/Header';
import RecoveryForm from '../../components/Recovery/RecoveryForm';
//import RecoveryAccept from '../../interface/RecoveryAccept';
import Success from '../../interface/Success';
import SMSCodeForm from '../../components/Recovery/SMSCodeForm';

import { LoginLoc } from '../../loc/login';
import { RecoveryLoc } from '../../loc/recovery';
import { loc } from '../../lib/loc';

export default function Recovery() {
    return (
        <>
            <Header title={loc(LoginLoc.recoveryPageTitle)} />
            <Switch>
                <Route exact path="/login/recovery/success">
                    <Success message={loc(RecoveryLoc.recoverySuccess.text)} title={loc(RecoveryLoc.recoverySuccess.title)} />{' '}
                </Route>
                <Route exact path="/login/recovery/accept/" component={SMSCodeForm} />
                <Route exact path="/login/recovery" component={RecoveryForm} />
            </Switch>
        </>
    );
}
